const facebookIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
    <circle cx="17" cy="17" r="17" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="m21.756 17.724.521-3.213h-3.256v-2.089c0-.879.453-1.738 1.912-1.738h1.48v-2.74a18.707 18.707 0 0 0-2.626-.217c-2.684 0-4.44 1.54-4.44 4.33v2.454h-2.98v3.218h2.98v7.776h3.668v-7.776h2.736l.005-.005Z"
    />
  </svg>
);

const instagramIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
    <circle cx="17" cy="17" r="17" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="M21.365 25.5h-8.797c-2.243 0-4.068-1.836-4.068-4.093v-8.04c0-2.258 1.825-4.094 4.068-4.094h8.797c2.243 0 4.068 1.836 4.068 4.094v8.04c0 2.257-1.825 4.093-4.068 4.093Zm-8.797-14.995c-1.568 0-2.844 1.284-2.844 2.861v8.04a2.856 2.856 0 0 0 2.844 2.863h8.797a2.856 2.856 0 0 0 2.844-2.862v-8.04a2.856 2.856 0 0 0-2.844-2.862h-8.797Z"
    />
    <path
      fill="#F8F3F0"
      d="M16.966 21.85c-2.455 0-4.453-2.011-4.453-4.483 0-2.471 1.998-4.482 4.453-4.482 2.456 0 4.454 2.011 4.454 4.482 0 2.472-1.998 4.482-4.454 4.482Zm0-7.733c-1.78 0-3.229 1.458-3.229 3.25s1.449 3.25 3.23 3.25c1.78 0 3.229-1.458 3.229-3.25s-1.449-3.25-3.23-3.25ZM21.914 13.317c.4 0 .724-.326.724-.729a.726.726 0 0 0-.724-.729c-.4 0-.724.327-.724.729 0 .403.324.729.724.729Z"
    />
  </svg>
);

const youtubeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
    <circle cx="17" cy="17" r="17" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="M26.049 21.547a2.366 2.366 0 0 1-1.67 1.67c-1.473.394-7.38.394-7.38.394s-5.907 0-7.38-.394a2.366 2.366 0 0 1-1.67-1.67C7.556 20.073 7.556 17 7.556 17s0-3.073.395-4.547a2.366 2.366 0 0 1 1.67-1.67c1.473-.394 7.38-.394 7.38-.394s5.906 0 7.379.395a2.366 2.366 0 0 1 1.67 1.67c.395 1.472.395 4.546.395 4.546s0 3.073-.395 4.547ZM15.067 14.21v5.58L20.004 17l-4.937-2.79Z"
    />
  </svg>
);

const telegramIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
    <circle cx="17" cy="17" r="17" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="M9.104 16.532s7.96-3.292 10.722-4.452c1.058-.463 4.647-1.948 4.647-1.948s1.657-.649 1.519.928c-.046.65-.414 2.922-.783 5.38-.552 3.478-1.15 7.281-1.15 7.281s-.092 1.067-.874 1.252c-.782.186-2.071-.649-2.301-.834-.184-.14-3.451-2.227-4.648-3.247-.322-.278-.69-.835.046-1.484a176.574 176.574 0 0 0 4.832-4.638c.552-.556 1.104-1.855-1.197-.278-3.267 2.272-6.488 4.406-6.488 4.406s-.736.464-2.117.046a95.286 95.286 0 0 1-2.99-.974s-1.105-.695.782-1.438Z"
    />
  </svg>
);

const xIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none">
    <circle cx="17.5" cy="17.5" r="17.5" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="m18.747 16.54 4.184-4.608h-1.544l-3.334 3.688-2.962-3.688h-3.954l4.921 6.171-4.47 4.965h1.496l3.667-4.044 3.257 4.044h3.856l-5.117-6.528Zm1.658 5.302-6.9-8.73h1.145l6.9 8.73h-1.145Z"
    />
  </svg>
);

const emailIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none">
    <circle cx="17.5" cy="17.5" r="17.5" fill="#F28741" />
    <path
      fill="#F8F3F0"
      d="M24.71 11.932H11.216c-1.662 0-1.662.525-1.662 1.443l-.008 8.656c0 1.311.257 1.443 1.67 1.443H24.71c1.285 0 1.542 0 1.542-1.443v-8.525c0-1.312 0-1.574-1.542-1.574Zm1.54 2.623-8.35 5.77-8.345-5.507v-1.443l8.344 5.508 8.35-5.77v1.442Z"
    />
  </svg>
);

const whatsappIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" fill="none">
    <circle cx="17" cy="17.5" r="17" fill="#F28741" />
    <path
      fill="#F9F9FB"
      d="M23.74 10.707a9.148 9.148 0 0 0-6.477-2.651c-5.049 0-9.157 4.056-9.157 9.04 0 1.593.42 3.15 1.22 4.522L8.028 26.3l4.855-1.258a9.222 9.222 0 0 0 4.377 1.1h.004c5.045 0 9.244-4.057 9.244-9.042 0-2.415-1.04-4.684-2.768-6.394Zm-6.477 13.912a7.67 7.67 0 0 1-3.877-1.046l-.277-.163-2.879.745.767-2.774-.181-.285a7.42 7.42 0 0 1-1.163-4c0-4.141 3.415-7.513 7.614-7.513 2.034 0 3.944.782 5.38 2.203 1.435 1.421 2.317 3.307 2.313 5.315 0 4.146-3.502 7.518-7.697 7.518Zm4.175-5.628c-.227-.114-1.353-.66-1.564-.733-.21-.078-.363-.114-.515.114-.153.228-.59.733-.726.887-.132.151-.268.172-.495.058-1.345-.664-2.228-1.186-3.115-2.688-.235-.4.235-.371.673-1.234.074-.151.037-.281-.021-.396-.058-.114-.516-1.225-.705-1.678-.186-.44-.376-.378-.516-.386-.132-.008-.285-.008-.437-.008-.153 0-.4.056-.61.28-.211.229-.801.774-.801 1.886 0 1.112.82 2.187.932 2.338.116.15 1.613 2.431 3.91 3.413 1.453.619 2.022.672 2.748.566.441-.065 1.353-.546 1.543-1.075.19-.53.19-.982.132-1.076-.054-.101-.207-.158-.433-.268Z"
    />
  </svg>
);
const linkedInIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" fill="none">
    <circle cx="17" cy="17.5" r="17" fill="#F28741" />
    <path
      fill="#F9F9FB"
      d="M12.922 25.227h-3.36V14.91h3.36v10.318ZM11.24 13.501c-1.08.005-1.966-.824-1.966-1.854 0-1.03.865-1.874 1.946-1.874 1.08 0 1.96.824 1.966 1.854 0 1.03-.87 1.865-1.946 1.874Zm14.262 11.726h-3.356v-5.024c0-1.197-.026-2.732-1.75-2.732s-2.017 1.3-2.017 2.644v5.107h-3.356V14.91h3.222v1.409h.046c.66-1.075 1.879-1.713 3.18-1.669 3.403 0 4.026 2.135 4.026 4.907v5.671h-.006.01Z"
    />
  </svg>
);

export {
  emailIcon,
  facebookIcon,
  instagramIcon,
  linkedInIcon,
  telegramIcon,
  whatsappIcon,
  xIcon,
  youtubeIcon,
};
